import * as THREE from 'three';
import * as dat from 'dat.gui';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
import { UnrealBloomPass } from 'three/addons/postprocessing/UnrealBloomPass.js';
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { OutlinePass } from 'three/addons/postprocessing/OutlinePass.js';

import bgTexture1 from '/images/1.jpg';
import bgTexture2 from '/images/2.jpg';
import bgTexture3 from '/images/3.jpg';
import bgTexture4 from '/images/4.jpg';
import sunTexture from '/images/sun.jpg';
import mercuryTexture from '/images/mercurymap.jpg';
import mercuryBump from '/images/mercurybump.jpg';
import venusTexture from '/images/venusmap.jpg';
import venusBump from '/images/venusmap.jpg';
import venusAtmosphere from '/images/venus_atmosphere.jpg';
import earthTexture from '/images/earth_daymap.jpg';
import earthNightTexture from '/images/earth_nightmap.jpg';
import earthAtmosphere from '/images/earth_atmosphere.jpg';
import earthMoonTexture from '/images/moonmap.jpg';
import earthMoonBump from '/images/moonbump.jpg';
import marsTexture from '/images/marsmap.jpg';
import marsBump from '/images/marsbump.jpg';
import jupiterTexture from '/images/jupiter.jpg';
import ioTexture from '/images/jupiterIo.jpg';
import europaTexture from '/images/jupiterEuropa.jpg';
import ganymedeTexture from '/images/jupiterGanymede.jpg';
import callistoTexture from '/images/jupiterCallisto.jpg';
import saturnTexture from '/images/saturnmap.jpg';
import satRingTexture from '/images/saturn_ring.png';
import uranusTexture from '/images/uranus.jpg';
import uraRingTexture from '/images/uranus_ring.png';
import neptuneTexture from '/images/neptune.jpg';
import plutoTexture from '/images/plutomap.jpg';

// ******  SETUP  ******
console.log("Create the scene");
const scene = new THREE.Scene();

console.log("Create a perspective projection camera");
var camera = new THREE.PerspectiveCamera( 45, window.innerWidth/window.innerHeight, 0.1, 1000 );
camera.position.set(-175, 115, 5);

console.log("Create the renderer");
const renderer = new THREE.WebGL1Renderer();
renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild(renderer.domElement);
renderer.toneMapping = THREE.ACESFilmicToneMapping;

console.log("Create an orbit control");
const controls = new OrbitControls(camera, renderer.domElement);
controls.enableDamping = true;
controls.dampingFactor = 0.75;
controls.screenSpacePanning = false;

console.log("Set up texture loader");
const cubeTextureLoader = new THREE.CubeTextureLoader();
const loadTexture = new THREE.TextureLoader();

// ******  POSTPROCESSING setup ******
const composer = new EffectComposer(renderer);
composer.addPass(new RenderPass(scene, camera));

// ******  OUTLINE PASS  ******
const outlinePass = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), scene, camera);
outlinePass.edgeStrength = 3;
outlinePass.edgeGlow = 1;
outlinePass.visibleEdgeColor.set(0xffffff);
outlinePass.hiddenEdgeColor.set(0x190a05);
composer.addPass(outlinePass);

// ******  BLOOM PASS  ******
const bloomPass = new UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 1, 0.4, 0.85);
bloomPass.threshold = 1;
bloomPass.radius = 0.9;
composer.addPass(bloomPass);

// ****** AMBIENT LIGHT ******
console.log("Add the ambient light");
var lightAmbient = new THREE.AmbientLight(0x222222, 6); 
scene.add(lightAmbient);

// ******  Star background  ******
scene.background = cubeTextureLoader.load([

  bgTexture3,
  bgTexture1,
  bgTexture2,
  bgTexture2,
  bgTexture4,
  bgTexture2
]);

// ******  CONTROLS  ******
const gui = new dat.GUI({ autoPlace: false });
const customContainer = document.getElementById('gui-container');
customContainer.appendChild(gui.domElement);

// Ubah teks Close Controls ke Bahasa Indonesia
const closeButton = gui.domElement.querySelector('.close-button');
if (closeButton) {
  closeButton.textContent = 'Tutup Kontrol';
  
  // Tambahkan event listener untuk mengganti teks saat diklik
  closeButton.addEventListener('click', function() {
    setTimeout(function() {
      if (gui.closed) {
        closeButton.textContent = 'Buka Kontrol';
      } else {
        closeButton.textContent = 'Tutup Kontrol';
      }
    }, 50);
  });
}
// ****** SETTINGS FOR INTERACTIVE CONTROLS  ******
const settings = {
  accelerationOrbit: 1,
  acceleration: 1,
  sunIntensity: 1.9,
  showQuiz: true
};

gui.add(settings, 'accelerationOrbit', 0, 10).name('Kecepatan Orbit').onChange(value => {
});
gui.add(settings, 'acceleration', 0, 10).name('Kecepatan Rotasi').onChange(value => {
});
gui.add(settings, 'sunIntensity', 1, 10).name('Intensitas Matahari').onChange(value => {
  sunMat.emissiveIntensity = value;
});

// mouse movement
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();

function onMouseMove(event) {
    event.preventDefault();
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
}

// ******  SELECT PLANET  ******
let selectedPlanet = null;
let isMovingTowardsPlanet = false;
let targetCameraPosition = new THREE.Vector3();
let offset;

function onDocumentMouseDown(event) {
  event.preventDefault();

  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;

  raycaster.setFromCamera(mouse, camera);
  var intersects = raycaster.intersectObjects(raycastTargets);

  if (intersects.length > 0) {
    const clickedObject = intersects[0].object;
    selectedPlanet = identifyPlanet(clickedObject);
    if (selectedPlanet) {
      closeInfoNoZoomOut();
      
      settings.accelerationOrbit = 0; // Stop orbital movement

      // Update camera to look at the selected planet
      const planetPosition = new THREE.Vector3();
      selectedPlanet.planet.getWorldPosition(planetPosition);
      controls.target.copy(planetPosition);
      camera.lookAt(planetPosition); // Orient the camera towards the planet

      targetCameraPosition.copy(planetPosition).add(camera.position.clone().sub(planetPosition).normalize().multiplyScalar(offset));
      isMovingTowardsPlanet = true;
    }
  }
}

function identifyPlanet(clickedObject) {
  // Logic to identify which planet was clicked based on the clicked object, different offset for camera distance
        if (clickedObject.material === mercury.planet.material) {
          offset = 10;
          return mercury;
        } else if (clickedObject.material === venus.Atmosphere.material) {
          offset = 25;
          return venus;
        } else if (clickedObject.material === earth.Atmosphere.material) {
          offset = 25;
          return earth;
        } else if (clickedObject.material === mars.planet.material) {
          offset = 15;
          return mars;
        } else if (clickedObject.material === jupiter.planet.material) {
          offset = 50;
          return jupiter;
        } else if (clickedObject.material === saturn.planet.material) {
          offset = 50;
          return saturn;
        } else if (clickedObject.material === uranus.planet.material) {
          offset = 25;
          return uranus;
        } else if (clickedObject.material === neptune.planet.material) {
          offset = 20;
          return neptune;
        } else if (clickedObject.material === pluto.planet.material) {
          offset = 10;
          return pluto;
        } 

  return null;
}

// ******  SHOW PLANET INFO AFTER SELECTION  ******
function showPlanetInfo(planet) {
  var info = document.getElementById('planetInfo');
  var name = document.getElementById('planetName');
  var details = document.getElementById('planetDetails');

  name.innerText = planet;
  details.innerText = `Radius: ${planetData[planet].radius}\nKemiringan: ${planetData[planet].kemiringan}\nRotasi: ${planetData[planet].rotasi}\nOrbit: ${planetData[planet].orbit}\nJarak: ${planetData[planet].jarak}\nBulan: ${planetData[planet].bulan}\nInfo: ${planetData[planet].info}`;

  info.style.display = 'block';
  initComparePlanet();
}
let isZoomingOut = false;
let zoomOutTargetPosition = new THREE.Vector3(-175, 115, 5);
// close 'x' button function
function closeInfo() {
  var info = document.getElementById('planetInfo');
  info.style.display = 'none';
  settings.accelerationOrbit = 1;
  isZoomingOut = true;
  controls.target.set(0, 0, 0);
}
window.closeInfo = closeInfo;
// close info when clicking another planet
function closeInfoNoZoomOut() {
  var info = document.getElementById('planetInfo');
  info.style.display = 'none';
  settings.accelerationOrbit = 1;
}
// ******  SUN  ******
let sunMat;

const sunSize = 697/40; // 40 times smaller scale than earth
const sunGeom = new THREE.SphereGeometry(sunSize, 32, 20);
sunMat = new THREE.MeshStandardMaterial({
  emissive: 0xFFF88F,
  emissiveMap: loadTexture.load(sunTexture),
  emissiveIntensity: settings.sunIntensity
});
const sun = new THREE.Mesh(sunGeom, sunMat);
scene.add(sun);

//point light in the sun
const pointLight = new THREE.PointLight(0xFDFFD3 , 1200, 400, 1.4);
scene.add(pointLight);


// ******  PLANET CREATION FUNCTION  ******
function createPlanet(planetName, size, position, tilt, texture, bump, ring, atmosphere, moons){

  let material;
  if (texture instanceof THREE.Material){
    material = texture;
  } 
  else if(bump){
    material = new THREE.MeshPhongMaterial({
    map: loadTexture.load(texture),
    bumpMap: loadTexture.load(bump),
    bumpScale: 0.7
    });
  }
  else {
    material = new THREE.MeshPhongMaterial({
    map: loadTexture.load(texture)
    });
  } 

  const name = planetName;
  const geometry = new THREE.SphereGeometry(size, 32, 20);
  const planet = new THREE.Mesh(geometry, material);
  const planet3d = new THREE.Object3D;
  const planetSystem = new THREE.Group();
  planetSystem.add(planet);
  let Atmosphere;
  let Ring;
  planet.position.x = position;
  planet.rotation.z = tilt * Math.PI / 180;

  // add orbit path
  const orbitPath = new THREE.EllipseCurve(
    0, 0,            // ax, aY
    position, position, // xRadius, yRadius
    0, 2 * Math.PI,   // aStartAngle, aEndAngle
    false,            // aClockwise
    0                 // aRotation
);

  const pathPoints = orbitPath.getPoints(100);
  const orbitGeometry = new THREE.BufferGeometry().setFromPoints(pathPoints);
  const orbitMaterial = new THREE.LineBasicMaterial({ color: 0xFFFFFF, transparent: true, opacity: 0.03 });
  const orbit = new THREE.LineLoop(orbitGeometry, orbitMaterial);
  orbit.rotation.x = Math.PI / 2;
  planetSystem.add(orbit);

  //add ring
  if(ring)
  {
    const RingGeo = new THREE.RingGeometry(ring.innerRadius, ring.outerRadius,30);
    const RingMat = new THREE.MeshStandardMaterial({
      map: loadTexture.load(ring.texture),
      side: THREE.DoubleSide
    });
    Ring = new THREE.Mesh(RingGeo, RingMat);
    planetSystem.add(Ring);
    Ring.position.x = position;
    Ring.rotation.x = -0.5 *Math.PI;
    Ring.rotation.y = -tilt * Math.PI / 180;
  }
  
  //add atmosphere
  if(atmosphere){
    const atmosphereGeom = new THREE.SphereGeometry(size+0.1, 32, 20);
    const atmosphereMaterial = new THREE.MeshPhongMaterial({
      map:loadTexture.load(atmosphere),
      transparent: true,
      opacity: 0.4,
      depthTest: true,
      depthWrite: false
    })
    Atmosphere = new THREE.Mesh(atmosphereGeom, atmosphereMaterial)
    
    Atmosphere.rotation.z = 0.41;
    planet.add(Atmosphere);
  }

  //add moons
  if(moons){
    moons.forEach(moon => {
      let moonMaterial;
      
      if(moon.bump){
        moonMaterial = new THREE.MeshStandardMaterial({
          map: loadTexture.load(moon.texture),
          bumpMap: loadTexture.load(moon.bump),
          bumpScale: 0.5
        });
      } else{
        moonMaterial = new THREE.MeshStandardMaterial({
          map: loadTexture.load(moon.texture)
        });
      }
      const moonGeometry = new THREE.SphereGeometry(moon.size, 32, 20);
      const moonMesh = new THREE.Mesh(moonGeometry, moonMaterial);
      const moonOrbitDistance = size * 1.5;
      moonMesh.position.set(moonOrbitDistance, 0, 0);
      planetSystem.add(moonMesh);
      moon.mesh = moonMesh;
    });
  }
  //add planet system to planet3d object and to the scene
  planet3d.add(planetSystem);
  scene.add(planet3d);
  return {name, planet, planet3d, Atmosphere, moons, planetSystem, Ring};
}


// ******  LOADING OBJECTS METHOD  ******
function loadObject(path, position, scale, callback) {
  const loader = new GLTFLoader();

  loader.load(path, function (gltf) {
      const obj = gltf.scene;
      obj.position.set(position, 0, 0);
      obj.scale.set(scale, scale, scale);
      scene.add(obj);
      if (callback) {
        callback(obj);
      }
  }, undefined, function (error) {
      console.error('An error happened', error);
  });
}

// ******  ASTEROIDS  ******
const asteroids = [];
function loadAsteroids(path, numberOfAsteroids, minOrbitRadius, maxOrbitRadius) {
  const loader = new GLTFLoader();
  loader.load(path, function (gltf) {
      gltf.scene.traverse(function (child) {
          if (child.isMesh) {
              for (let i = 0; i < numberOfAsteroids / 12; i++) { // Divide by 12 because there are 12 asteroids in the pack
                  const asteroid = child.clone();
                  const orbitRadius = THREE.MathUtils.randFloat(minOrbitRadius, maxOrbitRadius);
                  const angle = Math.random() * Math.PI * 2;
                  const x = orbitRadius * Math.cos(angle);
                  const y = 0;
                  const z = orbitRadius * Math.sin(angle);
                  child.receiveShadow = true;
                  asteroid.position.set(x, y, z);
                  asteroid.scale.setScalar(THREE.MathUtils.randFloat(0.8, 1.2));
                  scene.add(asteroid);
                  asteroids.push(asteroid);
              }
          }
      });
  }, undefined, function (error) {
      console.error('An error happened', error);
  });
}


// Earth day/night effect shader material
const earthMaterial = new THREE.ShaderMaterial({
  uniforms: {
    dayTexture: { type: "t", value: loadTexture.load(earthTexture) },
    nightTexture: { type: "t", value: loadTexture.load(earthNightTexture) },
    sunPosition: { type: "v3", value: sun.position }
  },
  vertexShader: `
    varying vec3 vNormal;
    varying vec2 vUv;
    varying vec3 vSunDirection;

    uniform vec3 sunPosition;

    void main() {
      vUv = uv;
      vec4 worldPosition = modelMatrix * vec4(position, 1.0);
      vNormal = normalize(modelMatrix * vec4(normal, 0.0)).xyz;
      vSunDirection = normalize(sunPosition - worldPosition.xyz);
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform sampler2D dayTexture;
    uniform sampler2D nightTexture;

    varying vec3 vNormal;
    varying vec2 vUv;
    varying vec3 vSunDirection;

    void main() {
      float intensity = max(dot(vNormal, vSunDirection), 0.0);
      vec4 dayColor = texture2D(dayTexture, vUv);
      vec4 nightColor = texture2D(nightTexture, vUv)* 0.2;
      gl_FragColor = mix(nightColor, dayColor, intensity);
    }
  `
});


// ******  MOONS  ******
// Earth
const earthMoon = [{
  size: 1.6,
  texture: earthMoonTexture,
  bump: earthMoonBump,
  orbitSpeed: 0.001 * settings.accelerationOrbit,
  orbitRadius: 10
}]

// Mars' moons with path to 3D models (phobos & deimos)
const marsMoons = [
  {
    modelPath: '/images/mars/phobos.glb',
    scale: 0.1,
    orbitRadius: 5,
    orbitSpeed: 0.002 * settings.accelerationOrbit,
    position: 100,
    mesh: null
  },
  {
    modelPath: '/images/mars/deimos.glb',
    scale: 0.1,
    orbitRadius: 9,
    orbitSpeed: 0.0005 * settings.accelerationOrbit,
    position: 120,
    mesh: null
  }
];

// Jupiter
const jupiterMoons = [
  {
    size: 1.6,
    texture: ioTexture,
    orbitRadius: 20,
    orbitSpeed: 0.0005 * settings.accelerationOrbit
  },
  {
    size: 1.4,
    texture: europaTexture,
    orbitRadius: 24,
    orbitSpeed: 0.00025 * settings.accelerationOrbit
  },
  {
    size: 2,
    texture: ganymedeTexture,
    orbitRadius: 28,
    orbitSpeed: 0.000125 * settings.accelerationOrbit
  },
  {
    size: 1.7,
    texture: callistoTexture,
    orbitRadius: 32,
    orbitSpeed: 0.00006 * settings.accelerationOrbit
  }
];

// ******  PLANET CREATIONS  ******
const mercury = new createPlanet('Merkurius', 2.4, 40, 0, mercuryTexture, mercuryBump);
const venus = new createPlanet('Venus', 6.1, 65, 3, venusTexture, venusBump, null, venusAtmosphere);
const earth = new createPlanet('Bumi', 6.4, 90, 23, earthMaterial, null, null, earthAtmosphere, earthMoon);
const mars = new createPlanet('Mars', 3.4, 115, 25, marsTexture, marsBump)
// Load Mars moons
marsMoons.forEach(moon => {
  loadObject(moon.modelPath, moon.position, moon.scale, function(loadedModel) {
    moon.mesh = loadedModel;
    mars.planetSystem.add(moon.mesh);
    moon.mesh.traverse(function (child) {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  });
});

const jupiter = new createPlanet('Jupiter', 69/4, 200, 3, jupiterTexture, null, null, null, jupiterMoons);
const saturn = new createPlanet('Saturnus', 58/4, 270, 26, saturnTexture, null, {
  innerRadius: 18, 
  outerRadius: 29, 
  texture: satRingTexture
});
const uranus = new createPlanet('Uranus', 25/4, 320, 82, uranusTexture, null, {
  innerRadius: 6, 
  outerRadius: 8, 
  texture: uraRingTexture
});
const neptune = new createPlanet('Neptunus', 24/4, 340, 28, neptuneTexture);
const pluto = new createPlanet('Pluto', 1, 350, 57, plutoTexture)

  // ******  PLANETS DATA  ******
  const planetData = {
  'Merkurius': {
      radius: '2.439,7 km',
      kemiringan: '0,03°',
      rotasi: '59 hari Bumi',
      orbit: '88 hari Bumi',
      jarak: '57,9 juta km',
      bulan: 'Tidak ada',
      info: 'Planet terkecil dan terdekat dengan Matahari. Permukaannya penuh kawah seperti Bulan.'
  },
  'Venus': {
      radius: '6.052 km',
      kemiringan: '177,4°',
      rotasi: '243 hari Bumi',
      orbit: '225 hari Bumi',
      jarak: '108 juta km',
      bulan: 'Tidak ada',
      info: 'Planet kedua dari Matahari, dikenal karena atmosfer tebal dan suhu yang sangat panas.'
  },
  'Bumi': {
      radius: '6.371 km',
      kemiringan: '23,5°',
      rotasi: '24 jam',
      orbit: '365 hari',
      jarak: '150 juta km',
      bulan: '1 (Bulan)',
      info: 'Satu-satunya planet yang diketahui memiliki kehidupan dan lautan air di permukaannya.'
  },
  'Mars': {
      radius: '3.390 km',
      kemiringan: '25,2°',
      rotasi: '24,6 jam',
      orbit: '687 hari Bumi',
      jarak: '228 juta km',
      bulan: '2 (Phobos dan Deimos)',
      info: 'Dikenal sebagai Planet Merah karena warna permukaannya yang berkarat.'
  },
  'Jupiter': {
      radius: '69.911 km',
      kemiringan: '3.1°',
      rotasi: '10 jam',
      orbit: '12 tahun Bumi',
      jarak: '778 juta km',
      bulan: '95 bulan (terbesar: Ganymede, Callisto, Europa, Io)',
      info: 'Planet terbesar di tata surya dengan badai raksasa bernama Great Red Spot.'
  },
  'Saturnus': {
      radius: '58.232 km',
      kemiringan: '26,7°',
      rotasi: '10,7 jam',
      orbit: '29 tahun Bumi',
      jarak: '1,4 miliar km',
      bulan: '146 bulan',
      info: 'Memiliki sistem cincin paling indah dan luas di antara planet lain.'
  },
  'Uranus': {
      radius: '25.362 km',
      kemiringan: '97,8°',
      rotasi: '17 jam',
      orbit: '84 tahun Bumi',
      jarak: '2,9 miliar km',
      bulan: '27 bulan',
      info: 'Planet ini berputar miring ke samping dan berwarna biru pucat.'
  },
  'Neptunus': {
      radius: '24.622 km',
      kemiringan: '28,3°',
      rotasi: '16 jam',
      orbit: '165 tahun Bumi',
      jarak: '4,5 miliar km',
      bulan: '14 bulan',
      info: 'Planet terjauh dari Matahari dengan angin tercepat di tata surya.'
  },
  'Pluto': {
      radius: '1.188 km',
      kemiringan: '122,5°',
      rotasi: '6,4 hari Bumi',
      orbit: '248 tahun Bumi',
      jarak: '5,9 miliar km',
      bulan: '5 (Charon, Styx, Nix, Kerberos, Hydra)',
      info: 'Sekarang diklasifikasikan sebagai planet katai, bukan planet utama.'
  }
};



// Array of planets and atmospheres for raycasting
const raycastTargets = [
  mercury.planet, venus.planet, venus.Atmosphere, earth.planet, earth.Atmosphere, 
  mars.planet, jupiter.planet, saturn.planet, uranus.planet, neptune.planet, pluto.planet
];

// ******  SHADOWS  ******
renderer.shadowMap.enabled = true;
pointLight.castShadow = true;

//properties for the point light
pointLight.shadow.mapSize.width = 1024;
pointLight.shadow.mapSize.height = 1024;
pointLight.shadow.camera.near = 10;
pointLight.shadow.camera.far = 20;

//casting and receiving shadows
earth.planet.castShadow = true;
earth.planet.receiveShadow = true;
earth.Atmosphere.castShadow = true;
earth.Atmosphere.receiveShadow = true;
earth.moons.forEach(moon => {
moon.mesh.castShadow = true;
moon.mesh.receiveShadow = true;
});
mercury.planet.castShadow = true;
mercury.planet.receiveShadow = true;
venus.planet.castShadow = true;
venus.planet.receiveShadow = true;
venus.Atmosphere.receiveShadow = true;
mars.planet.castShadow = true;
mars.planet.receiveShadow = true;
jupiter.planet.castShadow = true;
jupiter.planet.receiveShadow = true;
jupiter.moons.forEach(moon => {
  moon.mesh.castShadow = true;
  moon.mesh.receiveShadow = true;
  });
saturn.planet.castShadow = true;
saturn.planet.receiveShadow = true;
saturn.Ring.receiveShadow = true;
uranus.planet.receiveShadow = true;
neptune.planet.receiveShadow = true;
pluto.planet.receiveShadow = true;




function animate(){

  //rotating planets around the sun and itself
  sun.rotateY(0.001 * settings.acceleration);
  mercury.planet.rotateY(0.001 * settings.acceleration);
  mercury.planet3d.rotateY(0.004 * settings.accelerationOrbit);
  venus.planet.rotateY(0.0005 * settings.acceleration)
  venus.Atmosphere.rotateY(0.0005 * settings.acceleration);
  venus.planet3d.rotateY(0.0006 * settings.accelerationOrbit);
  earth.planet.rotateY(0.005 * settings.acceleration);
  earth.Atmosphere.rotateY(0.001 * settings.acceleration);
  earth.planet3d.rotateY(0.001 * settings.accelerationOrbit);
  mars.planet.rotateY(0.01 * settings.acceleration);
  mars.planet3d.rotateY(0.0007 * settings.accelerationOrbit);
  jupiter.planet.rotateY(0.005 * settings.acceleration);
  jupiter.planet3d.rotateY(0.0003 * settings.accelerationOrbit);
  saturn.planet.rotateY(0.01 * settings.acceleration);
  saturn.planet3d.rotateY(0.0002 * settings.accelerationOrbit);
  uranus.planet.rotateY(0.005 * settings.acceleration);
  uranus.planet3d.rotateY(0.0001 * settings.accelerationOrbit);
  neptune.planet.rotateY(0.005 * settings.acceleration);
  neptune.planet3d.rotateY(0.00008 * settings.accelerationOrbit);
  pluto.planet.rotateY(0.001 * settings.acceleration)
  pluto.planet3d.rotateY(0.00006 * settings.accelerationOrbit)

// Animate Earth's moon
if (earth.moons) {
  earth.moons.forEach(moon => {
    const time = performance.now();
    const tiltAngle = 5 * Math.PI / 180;

    const moonX = earth.planet.position.x + moon.orbitRadius * Math.cos(time * moon.orbitSpeed);
    const moonY = moon.orbitRadius * Math.sin(time * moon.orbitSpeed) * Math.sin(tiltAngle);
    const moonZ = earth.planet.position.z + moon.orbitRadius * Math.sin(time * moon.orbitSpeed) * Math.cos(tiltAngle);

    moon.mesh.position.set(moonX, moonY, moonZ);
    moon.mesh.rotateY(0.01);
  });
}
// Animate Mars' moons
if (marsMoons){
marsMoons.forEach(moon => {
  if (moon.mesh) {
    const time = performance.now();

    const moonX = mars.planet.position.x + moon.orbitRadius * Math.cos(time * moon.orbitSpeed);
    const moonY = moon.orbitRadius * Math.sin(time * moon.orbitSpeed);
    const moonZ = mars.planet.position.z + moon.orbitRadius * Math.sin(time * moon.orbitSpeed);

    moon.mesh.position.set(moonX, moonY, moonZ);
    moon.mesh.rotateY(0.001);
  }
});
}

// Animate Jupiter's moons
if (jupiter.moons) {
  jupiter.moons.forEach(moon => {
    const time = performance.now();
    const moonX = jupiter.planet.position.x + moon.orbitRadius * Math.cos(time * moon.orbitSpeed);
    const moonY = moon.orbitRadius * Math.sin(time * moon.orbitSpeed);
    const moonZ = jupiter.planet.position.z + moon.orbitRadius * Math.sin(time * moon.orbitSpeed);

    moon.mesh.position.set(moonX, moonY, moonZ);
    moon.mesh.rotateY(0.01);
  });
}

// Rotate asteroids
asteroids.forEach(asteroid => {
  asteroid.rotation.y += 0.0001;
  asteroid.position.x = asteroid.position.x * Math.cos(0.0001 * settings.accelerationOrbit) + asteroid.position.z * Math.sin(0.0001 * settings.accelerationOrbit);
  asteroid.position.z = asteroid.position.z * Math.cos(0.0001 * settings.accelerationOrbit) - asteroid.position.x * Math.sin(0.0001 * settings.accelerationOrbit);
});

// ****** OUTLINES ON PLANETS ******
raycaster.setFromCamera(mouse, camera);

// Check for intersections
var intersects = raycaster.intersectObjects(raycastTargets);

// Reset all outlines
outlinePass.selectedObjects = [];

if (intersects.length > 0) {
  const intersectedObject = intersects[0].object;

  // If the intersected object is an atmosphere, find the corresponding planet
  if (intersectedObject === earth.Atmosphere) {
    outlinePass.selectedObjects = [earth.planet];
  } else if (intersectedObject === venus.Atmosphere) {
    outlinePass.selectedObjects = [venus.planet];
  } else {
    // For other planets, outline the intersected object itself
    outlinePass.selectedObjects = [intersectedObject];
  }
}
// ******  ZOOM IN/OUT  ******
if (isMovingTowardsPlanet) {
  // Smoothly move the camera towards the target position
  camera.position.lerp(targetCameraPosition, 0.03);

  // Check if the camera is close to the target position
  if (camera.position.distanceTo(targetCameraPosition) < 1) {
      isMovingTowardsPlanet = false;
      showPlanetInfo(selectedPlanet.name);

  }
} else if (isZoomingOut) {
  camera.position.lerp(zoomOutTargetPosition, 0.05);

  if (camera.position.distanceTo(zoomOutTargetPosition) < 1) {
      isZoomingOut = false;
  }
}
  if (!scene || !renderer) return;

  // Tambahkan pengecekan sebelum merender
  if (composer.passes.length > 0) {
    composer.render();
  } else {
    renderer.render(scene, camera);
  }

  // Update controls
  controls.update();

  controls.update();
  requestAnimationFrame(animate);
  composer.render();
}
loadAsteroids('/asteroids/asteroidPack.glb', 1000, 130, 160);
loadAsteroids('/asteroids/asteroidPack.glb', 3000, 352, 370);
animate();

window.addEventListener('mousemove', onMouseMove, false);
window.addEventListener('mousedown', onDocumentMouseDown, false);
window.addEventListener('resize', function(){
  camera.aspect = window.innerWidth/window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth,window.innerHeight);
  composer.setSize(window.innerWidth,window.innerHeight);
});

// ==== FITUR KUIS EDUKATIF (bisa diulang & random pertanyaan) ====

// Bank soal (lebih banyak pertanyaan)
const allQuestions = [
  { q: "Planet terbesar di tata surya adalah...", a: "Jupiter", options: ["Mars", "Bumi", "Jupiter", "Saturnus"] },
  { q: "Planet terdekat dengan Matahari adalah...", a: "Merkurius", options: ["Venus", "Mars", "Merkurius", "Bumi"] },
  { q: "Planet yang dikenal sebagai planet merah adalah...", a: "Mars", options: ["Mars", "Saturnus", "Neptunus", "Venus"] },
  { q: "Bulan adalah satelit alami dari...", a: "Bumi", options: ["Mars", "Bumi", "Jupiter", "Saturnus"] },
  { q: "Planet terjauh dari Matahari adalah...", a: "Neptunus", options: ["Uranus", "Neptunus", "Pluto", "Saturnus"] },
  { q: "Planet yang memiliki cincin paling indah adalah...", a: "Saturnus", options: ["Uranus", "Jupiter", "Saturnus", "Neptunus"] },
  { q: "Planet yang disebut kembaran Bumi adalah...", a: "Venus", options: ["Mars", "Venus", "Merkurius", "Saturnus"] },
  { q: "Planet yang memiliki rotasi paling cepat adalah...", a: "Jupiter", options: ["Mars", "Jupiter", "Saturnus", "Bumi"] },
  { q: "Planet berwarna biru pucat dan berputar miring ke samping adalah...", a: "Uranus", options: ["Neptunus", "Uranus", "Bumi", "Venus"] },
  { q: "Planet yang tidak memiliki bulan adalah...", a: "Venus", options: ["Venus", "Mars", "Bumi", "Jupiter"] },
  { q: "Planet yang dulunya dianggap planet kesembilan adalah...", a: "Pluto", options: ["Pluto", "Neptunus", "Eris", "Ceres"] },
  { q: "Planet yang memiliki badai besar bernama Great Red Spot adalah...", a: "Jupiter", options: ["Jupiter", "Saturnus", "Mars", "Venus"] },
  { q: "Planet dengan suhu paling panas adalah...", a: "Venus", options: ["Merkurius", "Mars", "Venus", "Bumi"] },
  { q: "Planet yang memiliki hari lebih panjang dari tahunnya adalah...", a: "Venus", options: ["Mars", "Venus", "Bumi", "Merkurius"] },
  { q: "Planet yang memiliki paling banyak bulan adalah...", a: "Saturnus", options: ["Jupiter", "Uranus", "Saturnus", "Neptunus"] }
];

// Fungsi untuk acak array (Fisher-Yates shuffle)
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

let questions = [];
let currentQ = 0;
let score = 0;

const quizContainer = document.getElementById('quiz-container');
const result = document.getElementById('quiz-result');

// Fungsi untuk memulai kuis baru
function startQuiz() {
  score = 0;
  currentQ = 0;
  result.textContent = "";
  questions = shuffleArray([...allQuestions]).slice(0, 5); // ambil 5 pertanyaan acak
  loadQuestion();
}

// Fungsi menampilkan pertanyaan
function loadQuestion() {
  const q = questions[currentQ];
  quizContainer.innerHTML = `
    <p>${currentQ + 1}. ${q.q}</p>
    ${shuffleArray(q.options)
      .map(opt => `<button class="opt-btn">${opt}</button>`)
      .join("")}
  `;
  document.querySelectorAll(".opt-btn").forEach(btn => {
    btn.onclick = () => {
      if (btn.textContent === q.a) score++;
      currentQ++;
      if (currentQ < questions.length) loadQuestion();
      else showResult();
    };
  });
}

// Fungsi hasil akhir
function showResult() {
  quizContainer.innerHTML = "";
  result.innerHTML = `
    🎉 Kuis selesai! Skor kamu: <b>${score}/${questions.length}</b><br><br>
    <button id="restart-btn">Ulangi Kuis</button>
  `;
  document.getElementById('restart-btn').onclick = startQuiz;
}

// Jalankan pertama kali
startQuiz();

// === Integrasi GUI dengan Panel Kuis ===

// Ambil elemen panel kuis
const quizPanel = document.getElementById("quiz-panel");

// Tambahkan properti ke settings
settings.showQuiz = true;

// Tambahkan kontrol ke GUI
gui.add(settings, "showQuiz").name("Tampilkan Kuis").onChange(value => {
  if (value) {
    quizPanel.classList.remove("hidden");
  } else {
    quizPanel.classList.add("hidden");
  }
});

// Default: tampilkan kuis
quizPanel.classList.remove("hidden");

// Add after planetData declaration

let comparingPlanet = null;

// Hapus fungsi yang duplikat dan perbaiki fungsi showPlanetComparison
function showPlanetComparison(planet1, planet2) {
  const planet1Obj = getPlanetObject(planet1);
  const planet2Obj = getPlanetObject(planet2);

  if (!planet1Obj || !planet2Obj) {
    console.error('Planet tidak ditemukan');
    return;
  }

  // Simpan posisi asli
  const originalPositions = new Map();
  Object.keys(planetData).forEach(name => {
    const planet = getPlanetObject(name);
    if (planet && planet.planetSystem) {
      originalPositions.set(name, planet.planetSystem.position.clone());
      planet.planetSystem.visible = false;
    }
  });

  // Tampilkan hanya planet yang dibandingkan
  planet1Obj.planetSystem.visible = true;
  planet2Obj.planetSystem.visible = true;

  // Atur posisi untuk perbandingan
  planet1Obj.planetSystem.position.set(-30, 0, 0);
  planet2Obj.planetSystem.position.set(30, 0, 0);

  // Update tampilan perbandingan
  document.getElementById('comparisonView').style.display = 'block';
  document.getElementById('planetInfo').style.display = 'none';
  
  // Update info perbandingan
  updateComparisonInfo(planet1, planet2);

  // Tambahkan tombol kembali
  addBackButton(originalPositions, planet1Obj, planet2Obj);

  // Atur kamera untuk tampilan perbandingan
  setupComparisonCamera();
}

// Fungsi helper untuk update info perbandingan
function updateComparisonInfo(planet1, planet2) {
  const createPlanetInfo = (planet) => `
    <h2>${planet}</h2>
    <div class="planet-compare-details">
      <p><strong>Radius:</strong> ${planetData[planet].radius}</p>
      <p><strong>Jarak dari Matahari:</strong> ${planetData[planet].jarak}</p>
      <p><strong>Rotasi:</strong> ${planetData[planet].rotasi}</p>
      <p><strong>Orbit:</strong> ${planetData[planet].orbit}</p>
      <p><strong>Bulan:</strong> ${planetData[planet].bulan}</p>
    </div>
  `;

  document.getElementById('planet1View').innerHTML = createPlanetInfo(planet1);
  document.getElementById('planet2View').innerHTML = createPlanetInfo(planet2);
}

// Fungsi untuk menambahkan tombol kembali
function addBackButton(originalPositions, planet1Obj, planet2Obj) {
  const backBtn = document.createElement('button');
  backBtn.innerHTML = 'Kembali ke Tata Surya';
  backBtn.className = 'compare-btn';
  backBtn.onclick = () => resetComparison(originalPositions, planet1Obj, planet2Obj);
  document.querySelector('.comparison-content').appendChild(backBtn);
}

// Fungsi untuk reset perbandingan
function resetComparison(originalPositions, planet1Obj, planet2Obj) {
  // Kembalikan posisi semua planet
  originalPositions.forEach((position, planetName) => {
    const planet = getPlanetObject(planetName);
    if (planet && planet.planetSystem) {
      planet.planetSystem.position.copy(position);
      planet.planetSystem.visible = true;
    }
  });

  // Reset tampilan
  document.getElementById('comparisonView').style.display = 'none';
  document.getElementById('planetSelector').style.display = 'none';

  // Reset kamera
  camera.position.copy(zoomOutTargetPosition);
  controls.target.set(0, 0, 0);
}

// Fungsi untuk setup kamera perbandingan
function setupComparisonCamera() {
  camera.position.set(0, 30, 100);
  controls.target.set(0, 0, 0);
  controls.update();
}

// Perbarui fungsi initComparePlanet
function initComparePlanet() {
  const compareBtn = document.getElementById('compareBtn');
  if (!compareBtn) return;

  compareBtn.onclick = () => {
    const planetSelector = document.getElementById('planetSelector');
    const planetOptions = document.getElementById('planetOptions');
    planetOptions.innerHTML = '';

    Object.keys(planetData).forEach(planetName => {
      if (planetName !== selectedPlanet.name) {
        const option = document.createElement('div');
        option.className = 'planet-option';
        option.textContent = planetName;
        option.onclick = () => {
          planetSelector.style.display = 'none';
          showPlanetComparison(selectedPlanet.name, planetName);
        };
        planetOptions.appendChild(option);
      }
    });

    planetSelector.style.display = 'block';
  };
}

function resetView() {
  // Kembalikan visibilitas semua planet
  Object.keys(planetData).forEach(planetName => {
    const planetObj = getPlanetObject(planetName);
    if (planetObj && planetObj.planetSystem) {
      planetObj.planetSystem.visible = true;
    }
  });

  // Reset camera position
  camera.position.copy(zoomOutTargetPosition);
  controls.target.set(0, 0, 0);

  // Pastikan lighting kembali
  scene.add(lightAmbient);
  scene.add(pointLight);

  // Reset render settings
  renderer.setSize(window.innerWidth, window.innerHeight);
  composer.setSize(window.innerWidth, window.innerHeight);
}

function getPlanetObject(planetName) {
  try {
    switch(planetName) {
      case 'Merkurius': return mercury;
      case 'Venus': return venus;
      case 'Bumi': return earth;
      case 'Mars': return mars;
      case 'Jupiter': return jupiter;
      case 'Saturnus': return saturn;
      case 'Uranus': return uranus;
      case 'Neptunus': return neptune;
      case 'Pluto': return pluto;
      default: return null;
    }
  } catch (error) {
    console.error('Error getting planet object:', error);
    return null;
  }
}